// Authored opening line lengths. Verify against MDX when changing a course.
export const openingLessonManifest = {
    "caro-kann-defense": {
        practice: [10, 10],
        challenge: [10],
    },
    "danish-gambit": {
        practice: [10, 9],
        challenge: [10],
    },
    "english-opening": {
        practice: [8, 8],
        challenge: [8],
    },
    "french-defense": {
        practice: [9, 9],
        challenge: [9],
    },
    "fried-liver-attack": {
        practice: [8, 10],
        challenge: [8],
    },
    "italian-game": {
        practice: [10, 10],
        challenge: [10],
    },
    "kings-indian-defense": {
        practice: [10, 10],
        challenge: [10],
    },
    "london-system": {
        practice: [10, 10],
        challenge: [10],
    },
    "queens-gambit-declined": {
        practice: [8, 7],
        challenge: [8],
    },
    "queens-gambit": {
        practice: [9, 9],
        challenge: [9],
    },
    "ruy-lopez": {
        practice: [10, 10],
        challenge: [10],
    },
    "scandinavian-defense": {
        practice: [8, 6],
        challenge: [8],
    },
    "scotch-game": {
        practice: [8, 7],
        challenge: [8],
    },
    "sicilian-defense": {
        practice: [9, 9],
        challenge: [9],
    },
    "slav-defense": {
        practice: [8, 7],
        challenge: [8],
    },
};
//# sourceMappingURL=openingLessonManifest.js.map